var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 390.095,
    height: 153.455,
    viewBox: "0 0 390.095 153.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.23,
    y1: 0.053,
    x2: 0.15,
    y2: 0.195,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db161a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#85171a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5d1214"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_17",
    "data-name": "Grupo 17",
    transform: "translate(-1434.905 -249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16",
    "data-name": "Grupo 16",
    transform: "translate(1435 249)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13",
    "data-name": "Grupo 13",
    transform: "translate(0 28)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3",
    "data-name": "Trazado 3",
    d: "M0,0v123.69H390V62.323c-27.168,25.538-89.1,45.221-138.447,41.035C171.706,96.585,127.464,0,0,0",
    transform: "translate(0 -0.001)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_15",
    "data-name": "Grupo 15",
    transform: "translate(1434.905 248.999)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_13-2",
    "data-name": "Grupo 13",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3-2",
    "data-name": "Trazado 3",
    d: "M390.095,0V153.456H0V62.338c27.175,25.544,89.125,45.232,138.481,41.045C218.347,96.608,262.6,0,390.095,0",
    transform: "translate(0 -0.001)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.2dd00fbc2be41f4817a96c6fd712d34e.svg";
export { ForwardRef as ReactComponent };